/* eslint-disable react/display-name */
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './card.module.scss'

const Card = React.forwardRef(({ className, children, onClick }, ref) => {
  const classes = classNames(styles.container, className)
  return (
    <div ref={ref} className={classes} onClick={onClick}>
      {children}
    </div>
  )
})

Card.defaultProps = {
  className: null,
  onClick: null
}

Card.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.node
  ]).isRequired
}

export default Card
